var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgGitlab = function SvgGitlab(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.48 27.116 44.844 19 39.615 2.91c-.268-.827-1.44-.827-1.708 0l-5.228 16.089H15.321L10.094 2.91c-.27-.827-1.44-.827-1.71 0L3.159 18.999.519 27.116a1.797 1.797 0 0 0 .653 2.01L24 45.71l22.828-16.585a1.797 1.797 0 0 0 .652-2.009",
    fill: "#FC6D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45.71 32.679 19H15.321L24 45.709v.001Z",
    fill: "#E24329"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45.71 15.321 19H3.157L24 45.709v.001Z",
    fill: "#FC6D26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.157 18.998.52 27.117a1.796 1.796 0 0 0 .652 2.009L24 45.71 3.157 19Z",
    fill: "#FCA326"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.157 18.999h12.164L10.094 2.91c-.27-.827-1.44-.827-1.71 0L3.158 18.999Z",
    fill: "#E24329"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45.71 32.679 19h12.164L24 45.709v.001Z",
    fill: "#FC6D26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m44.843 18.998 2.638 8.118a1.795 1.795 0 0 1-.653 2.009L24 45.71 44.843 19Z",
    fill: "#FCA326"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.843 18.999H32.679L37.907 2.91c.269-.827 1.44-.827 1.709 0L44.843 19v-.001Z",
    fill: "#E24329"
  })));
};

export default SvgGitlab;